export const PKG_NAME = "@hpcc-js/form";
export const PKG_VERSION = "2.12.7";
export const BUILD_VERSION = "2.108.11";
